import styled from 'styled-components'

export const Article = styled.article`
  min-height: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;

  ${p => p.theme.mq.upMd} {
    min-height: ${p => p.theme.blocks.heightMinResultsMd};
  }

  ${p => p.theme.mq.upLg} {
    min-height: ${p => p.theme.blocks.heightMinResultsLg};
  }
`

export const FrameWrapper = styled.div`
  position: relative;
  min-height: ${p => p.theme.blocks.heightMinResults};

  ${p => p.theme.mq.upMd} {
    overflow: hidden;
  }

  .browser > div {
    min-width: 0;
  }
`

export const BgMovedBlock = styled.div`
  background: ${p => p.theme.colors.catskillWhite};
  width: 100vw;
  transform: translateX(-70%);
`

export const Cover = styled.div`
  display: block;
  position: absolute;
  height: 100%;
  width: 90%;
  right: 0;
  background: ${p => p.theme.colors.catskillWhite};

  ${p => p.theme.mq.upMd} {
    display: none;
  }
`
